
import React from 'react';
import {Link} from 'react-router-dom';
import Chip from 'material-ui/Chip';

import LinearProgress from 'material-ui/LinearProgress';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentCreate from 'material-ui/svg-icons/content/create';

import * as colors from 'material-ui/styles/colors';

import * as commons from '../../commons';

import Decimal from 'decimal.js'

const basicListFontStyle = {
  fontSize: 13, 
  color: colors.grey600
}

const convertZero = (value) => {
  if (!value || value === 0) {
    return 'ー'
  } else {
    return value
  }
}

const arariBudgetTip = (yosan) => {
  return yosan.budget == 0 ? 'ー' : convertZero(yosan.budgetAvg)
}

const arariResultTip = (yosan) => {
  return yosan.result == 0 ? 'ー' : convertZero(yosan.resultAvg)
}

const statusTip = (yosan) => {
  if(yosan.status === 0) {
    return "承認待"
  } else if (yosan.status === 1) {
    return "承認済"
  } else if (yosan.status === 2) {
    return "着工中"
  } else if (yosan.status === 3) {
    return "完工"
  }
}


export const createYosanList = (yosan, startDate, endDate) => {

  let startDateYYYYMM = '';
  let endDateYYYYMM = '';

  let query = ''
  if (startDate) {
    query += '&startDate=' + startDate.format('YYYYMM');
  }
  if (endDate) {
    query += '&endDate=' + endDate.format('YYYYMM');
  }

  const arari = yosan.orderAmmount - yosan.result

  let orderArari = 0
  let orderArariAvg = 0
  if (yosan.orderAmmount != 0) {
    orderArari = yosan.orderAmmount - yosan.result
    orderArariAvg = Math.floor(new Decimal(orderArari).div(yosan.orderAmmount).times(100).toNumber())
  }

  let claimArari = 0
  let claimArariAvg = 0
  if (yosan.claimAmmount != 0) {
      claimArari = yosan.claimAmmount - yosan.result
      claimArariAvg = Math.floor(new Decimal(claimArari).div(yosan.claimAmmount).times(100).toNumber())
  }

  const linearColor = claimArari > 0 ? colors.blue700 : colors.red400

  let linear
  if (yosan.orderAmmount !== 0) {
    linear = (yosan.claimAmmount / yosan.orderAmmount) * 100
  } else {
    linear = 0
  }

  return {
    office: 
      <div>
        <div style={{marginBottom: 3}}>
          <span style={basicListFontStyle}>{yosan.branchOfficeName}</span>
        </div>
        <div>
          <span style={basicListFontStyle}>{yosan.departmentName}</span>
        </div>
      </div>,
    officeTip:
      `${yosan.branchOfficeName}  ${yosan.departmentName}`
    ,
    kenmei1: 
      <div>
        <div style={{marginBottom: 3}}>
          <span style={basicListFontStyle}>{yosan.kenmeiCode}</span>
        </div>
        <div>
          <span style={basicListFontStyle}>{yosan.kenmeiName}</span>
        </div>
      </div>
    ,
    kenmei1Tip:
      `${yosan.kenmeiCode}  ${yosan.kenmeiName}`
    ,
    linear:

      <div>
        <div className='row'>
          <div className='col' style={{height: '100%', alignContent: 'flex-end'}}>
            <div>
              <span style={{ fontSize: 11, color: colors.grey600 }}>請求 / 受注</span>
            </div>
          </div>
          <div className='col' style={{display: 'flex', justifyContent: 'flex-end'}}>
            <div>
            <span style={
              {
                fontSize: 15,
                fontWeight: 'lighter',
                color: yosan.claimAmmount != 0 ? linearColor : colors.grey600
              }}>
              {convertZero(commons.dispMoney(yosan.claimAmmount))}
            </span>
            <span style={{ fontSize: 10, color: colors.grey600 }}>&nbsp;/&nbsp;</span>
            <span style={{ fontSize: 10, color: colors.grey600 }}>{convertZero(commons.dispMoney(yosan.orderAmmount))}</span>
            </div>
          </div>
        </div>
        <LinearProgress
          color={linearColor}
          mode="determinate" value={linear} />
      </div>
    ,
    linearTip:
    `${convertZero(commons.dispMoney(yosan.claimAmmount))} / ${convertZero(commons.dispMoney(yosan.orderAmmount))}`
    ,
    arari: 
      <div>
        <div style={{marginBottom: 3}}>
          <span style={{ fontSize: 13, color: colors.grey600 }}>請 : {convertZero(claimArariAvg)}&nbsp;%</span>
        </div>
        <div>
          <span style={{ fontSize: 13, color: colors.grey600 }}>受 : {convertZero(orderArariAvg)}&nbsp;%</span>
        </div>
      </div>
    ,
    arariTip:
    `請：${convertZero(claimArariAvg)}%  受：${convertZero(orderArariAvg)}%`
    ,
    status: 
      <div>
        {yosan.status === 0 &&
          <Chip style={{ borderRadius: 0 }} backgroundColor={colors.pink300}>
            <span style={{ color: colors.white }}>承認待</span>
          </Chip>
        }
        {yosan.status === 1 &&
          <Chip style={{ borderRadius: 0 }} backgroundColor={colors.green400}>
            <span style={{ color: colors.white }}>承認済</span>
          </Chip>
        }
        {yosan.status === 2 &&
          <Chip style={{ borderRadius: 0 }} backgroundColor={colors.blue400}>
            <span style={{ color: colors.white }}>着工中</span>
          </Chip>
        }
        {yosan.status === 3 &&
          <Chip style={{ borderRadius: 0 }} backgroundColor={colors.grey700}>
            <span style={{ color: colors.white }}>完工</span>
          </Chip>
        }
      </div>
    ,
    statusTip:
    `${statusTip(yosan)}`
    ,
    actions: 
      <div style={{ margin: '10px 0' }}>
        <Link className="button" to={`/yosan/${yosan.id}?${query}`}>
          <FloatingActionButton zDepth={0}
            mini={true}
            backgroundColor={colors.grey400}
          //iconStyle={{fill: blue300}}>
          >
            <ContentCreate />
          </FloatingActionButton>
        </Link>
      </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/yosan/createYosanList.js